import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import React from "react";
import "./vacationNotice.scss";

const VACATION_ON = false;
const STORAGE_KEY = "bk_vacation_notice_dismissed";

const VacationNotice = () => {
  const [dismissed, setDismissed] = React.useState(false);

  React.useEffect(() => {
    try {
      const value = sessionStorage.getItem(STORAGE_KEY);
      if (value === "1") setDismissed(true);
    } catch {}
  }, []);

  const effectiveShow = VACATION_ON && !dismissed;
  if (!effectiveShow) return null;

  const content = (
    <span>
      Kedves Könyvelőt Keresők! <br />
      <br /> A Bookkeepie Csapata és Könyvelő Partnereink nagy része is téli
      szabadságát tölti (2025.12.20-tól 2026.01.04-ig), ebben az időben kérlek
      kicsit lassabb ügyintézésre számítsatok. Amint visszatértünk,
      mindannyiótoknak segítünk!
    </span>
  );

  const handleClose = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, "1");
    } catch {}
    setDismissed(true);
  };

  return (
    <div className="vacation-notice" role="status" aria-live="polite">
      <div className="vacation-notice-content">{content}</div>
      <IconButton
        className="vacation-notice-close"
        onClick={handleClose}
        aria-label="Close"
        size="small"
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </div>
  );
};

export default VacationNotice;
